import React from 'react';
import { Box, Button, Container, Typography, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';

/**
 * Landing page for homeschool parent users.
 * Displayed when REACT_APP_FEATURE_HOMESCHOOL_PRIMARY is on and user is not authenticated.
 */
export const Landing: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        py: 4
      }}
    >
      <Container maxWidth="sm">
        <Paper
          sx={{
            p: 4,
            borderRadius: 2,
            textAlign: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            color: 'text.primary'
          }}
        >
          <Typography variant="h3" component="h1" sx={{ mb: 2, fontWeight: 'bold' }}>
            Level Up Learning
          </Typography>

          <Typography variant="h6" sx={{ mb: 4, color: 'text.secondary' }}>
            Understand what your child knows. See what comes next. Know it worked.
          </Typography>

          <Box sx={{ mb: 3 }}>
            <Typography variant="body1" paragraph>
              Stop guessing whether your child is learning at the right pace. Get evidence-based insights
              into their skills, clear recommendations for what to teach next, and measurable progress reports.
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mb: 3 }}>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={() => navigate('/signup', { state: { role: 'parent' } })}
            >
              Get Started
            </Button>
            <Button
              variant="outlined"
              color="primary"
              size="large"
              onClick={() => navigate('/login')}
            >
              Already a member? Log in
            </Button>
          </Box>

          <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 2 }}>
            We cover math and reading, grades 3–5, in Texas right now.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default Landing;
